import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';

import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { RouterState, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule } from '@ngx-translate/core';
import { PartialsModule } from '@partials/partials.module';
import { ThemeModule } from '@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';

/*Cookies*/
import { authInterceptorProviders } from '@core/security/interceptors/auth-interceptor.service';
import { errorHandlerInterceptorProviders } from '@core/security/interceptors/error-handler-interceptor.service';
import { metaReducers, reducers } from '@core/store';
import { EffectsArray } from '@core/store/effects';
import { CustomSerializer } from '@core/store/serializer/custom-serializer';
import { CookieService } from 'ngx-cookie-service';

import localeEs from '@angular/common/locales/es';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SwUpdateNotifierService } from '@utils/services/sw-update-notifier.service';
import { environment } from '../environments/environment';

registerLocaleData(localeEs, 'es');

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		ThemeModule,
		HttpClientModule,
		AppRoutingModule,
		PartialsModule,
		// METRONIC
		TranslateModule.forRoot(),

		// NGRX
		StoreModule.forRoot(reducers, { metaReducers }),
		// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
		EffectsModule.forRoot(EffectsArray),
		StoreRouterConnectingModule.forRoot({
			stateKey: 'router',
			routerState: RouterState.Minimal,
			serializer: CustomSerializer,
		}),
		StoreDevtoolsModule.instrument({ connectInZone: true }),
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: environment.production || environment.enableServiceWorker,
			registrationStrategy: environment.production
				? 'registerWhenStable:30000' // Production: wait for stability
				: 'registerWhenStable:5000', // Dev/QA: faster testing, still safe
		}),
	],
	providers: [
		{
			provide: LocationStrategy,
			useClass: HashLocationStrategy,
		},
		{
			provide: LOCALE_ID,
			useValue: 'es',
		},
		Title,
		CookieService,
		authInterceptorProviders,
		errorHandlerInterceptorProviders,
		SwUpdateNotifierService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
